/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:518px){.cb-special[_ngcontent-%COMP%]{position:absolute;bottom:0;height:86px;padding-left:140px}}@media (max-height:400px){.cb-special[_ngcontent-%COMP%]{position:static;height:auto}}.actions-special[_ngcontent-%COMP%]{padding-bottom:30px}.u-mt-xxl[_ngcontent-%COMP%]{margin-top:0!important}\n/*# sourceMappingURL=auth-user-activation.component.css.map*/"];
export { styles as styles };
